export const calculateLoanPointsPercentage= (loanPoints: number, loanAmount: number) => {
  if (!loanAmount) return 0

  const ltvRatio = (loanPoints / loanAmount) * 100;

  return Math.round(ltvRatio * 100) / 100; // Rounds to 2 decimal places
}
